function buildFromSecond(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return {
    hours,
    minutes,
    seconds: secs,
  };
}

type SupportedTimestampFormat = 'second' | 'millisecond' | 'microsecond' | 'nanosecond';
type SupportedStyle = 'narrow';

interface DurationFormatOptions {
  timestampFormat: SupportedTimestampFormat;
  style: SupportedStyle
}

const suffixes = {
  narrow: {
    hours: 'h',
    minutes: 'min',
    seconds: 's',
  },
};

export default class DurationFormat {
  unitsPerSecond: number;

  suffixes: { hours: string, minutes: string, seconds: string };

  constructor(
    options: DurationFormatOptions = { timestampFormat: 'millisecond', style: 'narrow' },
  ) {
    this.suffixes = suffixes[options.style];

    switch (options.timestampFormat) {
      case 'second':
        this.unitsPerSecond = 1;
        break;
      case 'millisecond':
        this.unitsPerSecond = 1000;
        break;
      case 'microsecond':
        this.unitsPerSecond = 1000000;
        break;
      case 'nanosecond':
        this.unitsPerSecond = 1000000000;
        break;
      default:
        throw new Error(`Unknown timestamp format: ${options.timestampFormat}`);
    }
  }

  format(duration: number): string {
    const { hours, minutes, seconds } = buildFromSecond(duration / this.unitsPerSecond);
    let result = `${seconds}${this.suffixes.seconds}`;
    if (minutes > 0) {
      result = `${minutes}${this.suffixes.minutes} ${result} `;
    }
    if (hours > 0) {
      result = `${hours}${this.suffixes.hours} ${result} `;
    }
    return result;
  }
}
